import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import details from '../views/details2.vue'
import seach from '../views/seach.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/details',
    name: 'details',
    component: details
  },
  {
    path: '/seach',
    name: 'seach',
    component: seach
  },

]

const router = new VueRouter({
  routes
})

export default router
